import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../shared/services/dashboard.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DataService } from '../shared/services/data.service';
import { TranslateDirective } from '../shared/translate.directive';
import { LicenceApplicationService } from '../shared/services/licence-application.service';
import { LoaderService } from '../shared/services/loader.service';
import { FormsModule } from '@angular/forms';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { getMacedonianPaginatorIntl } from '../custom-paginator-intl';
import { MatDatepickerLocComponent } from '../mat-datepicker-loc/mat-datepicker-loc.component';
import { MatIconModule } from '@angular/material/icon';
import { LanguageProvider } from '../shared/language-provider';
import { LoginService } from '../shared/services/login.service';


@Component({
  selector: 'app-applications-list',
  standalone: true,
  imports: [CommonModule, TranslateDirective, FormsModule, MatPaginatorModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatDatepickerLocComponent, MatIconModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'mk-MK' },
    provideNativeDateAdapter(),
    {
      provide: MatPaginatorIntl,
      useFactory: (provider: LanguageProvider) => getMacedonianPaginatorIntl(provider),
      deps: [LanguageProvider]
    }
  ],
  templateUrl: './applications-list.component.html',
  styleUrl: './applications-list.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationsListComponent implements OnInit {
  constructor(private service: DashboardService, private router: Router,
    private dataService: DataService, public licenseService: LicenceApplicationService,
    public myLoaderService: LoaderService , private loginService :LoginService) {
  }
  model: any = {
    Id: null
  }
  data: any
  applications: any;
  totalApplications: any;
  parkingTypes: any;
  permitTypes: any;
  parkingTypeId: any;
  InvalidDateFrom: boolean = false
  InvalidDateTo: boolean = false
  selectedDateFrom: Date | null = null;
  selectedDateTo: Date | null = null;
  searchModel: any = {
    Page: 1,
    Size: 5,
    ParkingTypeId: null,
    PermitTypeId: null,
    Registration: null,
    DateFrom: null,
    DateTo: null,
  }
  user :any;
  @ViewChild('datepickerFrom') datepickerFrom: MatDatepickerLocComponent | undefined;
  @ViewChild('datepickerTo') datepickerTo: MatDatepickerLocComponent | undefined;
  ngOnInit() {
    this.getParkingTypes();
    this.getAllAplications();
  }
  getAllAplications() {
    this.InvalidDateFrom = false;
    this.InvalidDateTo = false;
    const minDate = new Date(1753, 0, 1);

    if ((this.selectedDateFrom != null && this.selectedDateFrom < minDate)) {
      this.InvalidDateFrom = true;
    }
    if ((this.selectedDateTo != null && this.selectedDateTo < minDate)) {
      this.InvalidDateTo = true;
    }

    if (this.selectedDateFrom != null && this.selectedDateTo != null && this.selectedDateFrom > this.selectedDateTo) {
      this.InvalidDateTo = true;
    }

    if (this.InvalidDateFrom || this.InvalidDateTo) {
      return
    }

    this.searchModel.DateFrom = this.selectedDateFrom;
    this.searchModel.DateTo = this.selectedDateTo;
    this.searchModel.isAdmin = this.loginService.isAdmin();
    if(this.searchModel.isAdmin){
      this.user = this.loginService.getUser();
      this.searchModel.adminId = this.user.AdminId;

    }
    this.service.getAllApplications(this.searchModel).subscribe(res => {
      this.data = res
      this.applications = this.data.ApplicationGridRecords;
      this.totalApplications = this.data.TotalRecords;
    })

  }
  getParkingTypes() {
    this.licenseService.getAllParkingTypes().subscribe(res => {
      this.parkingTypes = res;
      // this.getPermitTypes();
    })
  }

  getPermitTypes() {
    this.licenseService.getAllPermitTypes(this.searchModel.ParkingTypeId , null).subscribe(res => {
      this.permitTypes = res;
    })

  }
  onDateSelectedFrom(date: Date) {
    this.selectedDateFrom = date

  }

  onDateSelectedTo(date: Date) {
    this.selectedDateTo = date
  }


  openDetails(app: any) {
    this.model.Id = app.Id;
    this.router.navigate(['application-details'],
      { queryParams: { id: this.model.Id } }
    );

  }

  pageEvent(event: any) {
    this.searchModel.Size = event.pageSize;
    this.searchModel.Page = event.pageIndex + 1;
    this.getAllAplications();
  }



  clearFilter() {
    this.searchModel.Page = 1;
    this.searchModel.Registration = '';
    this.searchModel.ParkingTypeId = null;
    this.searchModel.PermitTypeId = null;
    this.searchModel.DateFrom = null;
    this.searchModel.DateTo = null;
    this.selectedDateTo = null;
    this.selectedDateFrom = null;
    this.datepickerFrom?.clearDate();
    this.datepickerTo?.clearDate()
    this.getAllAplications()
  }


}
